<template>
  <ComponentCard title="Key lessons" icon="solar:star-shine-linear">
    <BlockField :model-value="attrs.title" placeholder="Title" :read-only="readOnly" input-class="text-sm font-bold text-[#1c4848]" @update:model-value="set({ title: $event })" />
    <div v-for="(item, i) in attrs.items" :key="i" class="flex items-start gap-2">
      <iconify-icon icon="solar:star-bold" class="mt-2 shrink-0 text-xs text-[#a0833c]" aria-hidden="true" />
      <div class="min-w-0 flex-1"><BlockField :model-value="item" placeholder="A lesson" :read-only="readOnly" input-class="text-[15px] text-[#1c4848]" @update:model-value="list.change(i, $event)" /></div>
      <RowActions v-if="!readOnly" :first="i === 0" :last="i === attrs.items.length - 1" @up="list.move(i, -1)" @down="list.move(i, 1)" @remove="list.remove(i)" />
    </div>
    <button v-if="!readOnly" type="button" class="min-h-9 rounded-lg px-2 text-xs font-bold text-[#1c4848]/60 hover:bg-[#1c4848]/5 hover:text-[#1c4848]" @click="list.add('')">+ Add a lesson</button>
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';
import RowActions from '@/components/writer/views/RowActions.vue';
import { useItems } from '@/components/writer/views/useItems.js';

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
const list = useItems(props);
</script>
